<template>
  <div id="gjs" style="height:0; overflow:hidden;background: #e2e5ec"></div>
</template>
<script>
import storage_init from '../storage/grapes-init';
import i18n from '../i18n/index.js';

import { mapGetters, mapActions } from 'vuex';
import '../plugins/facebook/index';
import '../plugins/linkedin/index';
import '../plugins/player/index';
import '../plugins/player-mp4/index';
import '../plugins/twitter/index';
import '../plugins/weather/index';
import '../plugins/clock/index';
import '../plugins/dateHeure/index';
import '../plugins/filet/index';
import '../plugins/countDown/index';

import '../plugins/playlist/index';
import '../plugins/webrtc/index';
import '../plugins/web/index';
import '../plugins/rss/index';
import '../plugins/live/index';
import '../plugins/ticker/index';
import '../plugins/image/index';
import '../plugins/pattern/index';
import '../plugins/medias/index';
import { HTTP } from '../core/http/http-token';
import Routing from '../core/router/router';
import en from '../i18n/en_US';
import fr from '../i18n/fr_FR';
import mixin from '../mixins/Mixin.js';
import SettingComponent from './Modal/SettingComponent';
import EditorImageComponent from './Modal/EditorImageComponent';
import mixinGrapes from '../mixins/GrapesMixinAnimation.js';
import mixinGrapesEvent from '../mixins/GrapesMixinEvent.js';
import mixinGrapesBlockManger from '../mixins/GrapesMixinBlockManger.js';
import mixinGrapesEditors from '../mixins/GrapesMixinEditors.js';
import mixinGrapesPanels from '../mixins/GrapesMixinPanels.js';
import mixinGrapesTranslate from '../mixins/GrapesMixinTranslate.js';
import mixinGrapesCommands from '../mixins/GrapesMixinCommands.js';
import postMixin from '../mixins/PostCssVw';
import mixinGrapesHelpers from '../mixins/GrapesMixinHelpers';
import EditorSvgMatorComponent from './Modal/EditorSvgMatorComponent';

import PerfectScrollbar from 'perfect-scrollbar';
import HasPermission from '../core/directives/HasPermission.js';
import { bus } from '../main';
export default {
  name: 'GrapesWrapper',
  components: {
    SettingComponent,
    EditorImageComponent,
    EditorSvgMatorComponent,
  },
  directives: {
    HasPermission,
  },
  mixins: [
    mixin,
    mixinGrapes,
    mixinGrapesEvent,
    mixinGrapesBlockManger,
    mixinGrapesEditors,
    mixinGrapesPanels,
    mixinGrapesTranslate,
    mixinGrapesCommands,
    postMixin,
    mixinGrapesHelpers,
  ],
  data() {
    return {
      oldBackgroundColor: null,
      editor: null,
      blockManager: null,
      currentScreen: null,
      idprev: null,
      panels: null,
      commands: null,
      modal: null,
      animate: null,
      showModal: false,
      textRTE: '',
      styleManager: null,
      mouseDown: false,
      pos1: 0,
      pos2: 0,
      pos3: 0,
      pos4: 0,
      videoObject: [],
      isvideoAutoplayed: 0,
      srcVideo: '',
      showToolbarButtons: true,
      confirmSave: false,
      fontsChanged: false,
      textSelected: true,
      blockSelected: true,
      modelToStyle: null,
      rectModal: {},
    };
  },
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  computed: {
    /**
     * Getters from Vuex Store
     */
    ...mapGetters({
      currentSlide: 'slides/getCurrent',
      selected: 'slides/getAllSelected',
      selectedSegments: 'segments/getAllSelected',
      templateTitle: 'slides/getTemplateTitle',
      dispositions: 'dispositions/getSelectedDispositions',
      screens: 'screens/getSelectedScreens',
      paramsClient: 'getParamsClients',
      getScreenPerId: 'screens/getScreenPerId',
      getDispositionPerId: 'dispositions/getDispositionPerId',
      getDispositionById: 'dispositions/getDispositionById',
      currentscreen: 'screens/getCurrentScreen',
      getTemplate: 'slides/getTemplate',
      deviceType: 'common/getDeviceType',
      parentWidth: 'common/getParentWidth',
      someImage: 'common/getSomeImage',
      showSave: 'common/getShowSave',
      showIconSave: 'common/getShowIconSave',
      changedSave: 'common/getChangedSave',
      editorReady: 'common/getEditorReady',
      getCurrentSlideIndex: 'slides/getCurrentSlideIndex',
      startGeneric: 'segments/getStartGeneric',
      finishGeneric: 'segments/getFinishGeneric',
      hasPermission: 'hasPermission',
      currentSegment: 'segments/getCurrent',
      saveVideo: 'common/getSaveVideo',
      reclamation: 'common/getReclamation',
      permission: 'getPermissions',
      imageWidth: 'common/getImageWidth',
      ListSvgObject: 'common/getListSvgObject',
      VideoGeneriqueDebut: 'getVideoGeneriqueDebut',
      VideoGeneriqueFin: 'getVideoGeneriqueFin',
      template: 'slides/getTemplate',
      totalDurationSegments: 'segments/getAllSegmentsDuration',
      biblioRoute: 'segments/getFromRouteBiblio',
      hasFullscreenVideo: 'segments/hasFullscreenVideo',
    }),
    all() {
      return this.screens.concat(this.dispositions);
    },
    setChangePreviewAttr() {
      return {
        title: this.$i18n.t('tooltips.preview_screens'),
        'data-tooltip-pos': 'bottom',
      };
    },
  },
  methods: {
    ...mapActions('slides', [
      'updateSlide',
      'setSlideDuration',
      'setTemplate',
      'setScreensTosubmit',
    ]),
    ...mapActions('common', [
      'setSettingModalPos',
      'setImageEdited',
      'setShowSave',
      'setChangedSave',
      'setShowIconSave',
      'setCauseReclamation',
      'setImageConverted',
      'setTitleVideoGeneriqueDebut',
      'setTitleVideoGeneriqueFin',
      'updateScreenbyId',
      'pushDisposition',
      'pushIdDispo',
    ]),

    ...mapActions(['updateScreenbyId', 'pushDisposition', 'pushIdDispo', 'setRoute']),
    ...mapActions('grapes', ['setEditor', 'setAssetManager']),
    ...mapActions('screens', [
      'setCurrentScreen',
      'setScreens',
      'setDurationScreen',
      'pushScreens',
      'deleteScreensById',
      'setComponentScreenByIndex',
      'updateScreenTitle',
      'setVideoIntro',
      'duplicateScreens',
    ]),
    ...mapActions('dispositions', [
      'setDispositions',
      'addDisposition',
      'unshiftDisposition',
      'deleteDispositionsById',
      'duplicateDisposition',
    ]),
    ...mapActions('segments', [
      'setCurrentSegment',
      'updateSegmentDuration',
      'removeBlankSlideToSegment',
      'updateSlideInsideSegment',
      'setTypeGeneric',
      'paginatesegment',
      'resetPage',
      'appendCreatedSegment',
      'deleteSegmentByIdStore',
    ]),
    showSetting() {
      var self = this;
      this.commands.add('show-setting', function() {
        self.$nextTick(function() {
          self.showModal = !self.showModal;
          const settingLayout = document.getElementById('setting-component');
          const settingCogs = document.querySelector('.gjs-toolbar .fa-cogs');
          settingLayout.classList.toggle('hidden');
          const rect = settingCogs.getBoundingClientRect();
          let { left, top } = rect;
          left -= 212;
          top += 30;
          this.setSettingModalPos({ left: Math.max(left, 0), top });
        });
      });
    },

    updateTarget(el, rect, options = {}) {
      const canvas = grapesjsEMP.editors[0].Canvas;
      const em = canvas.getConfig().em;
      this.modelToStyle = grapesjsEMP.editors[0].StyleManager.getModelToStyle(
        grapesjsEMP.editors[0].getSelected(),
      );
      let body = grapesjsEMP.editors[0].Canvas.getBody().getBoundingClientRect();
      let selected = grapesjsEMP.editors[0].getSelected().view.el.getBoundingClientRect();
      this.rectModal = {
        l: (selected.left * 100) / body.width,
        t: (selected.top * 100) / body.height,
        h: (selected.height * 100) / body.height,
        w: (selected.width * 100) / body.width,
        view: grapesjsEMP.editors[0].getSelected().view.el,
      };

      if (!this.modelToStyle) {
        return;
      }

      const { store, selectedHandler, config } = options;
      const { keyHeight, keyWidth, autoHeight, autoWidth, unitWidth, unitHeight } = config;
      const onlyHeight = ['tc', 'bc'].indexOf(selectedHandler) >= 0;
      const onlyWidth = ['cl', 'cr'].indexOf(selectedHandler) >= 0;
      const style = {};
      const en = !store ? 1 : ''; // this will trigger the final change
      const onlyTop = ['tc'].indexOf(selectedHandler) >= 0;
      const onlyTopLeft = ['tl'].indexOf(selectedHandler) >= 0;
      const onlyLeft = ['cl', 'bl'].indexOf(selectedHandler) >= 0;

      /*todo marouene fix redimensionnement d'image */
      if (!onlyHeight) {
        const bodyw = canvas.getBody().offsetWidth;
        const width = rect.w < bodyw ? rect.w : bodyw;
        style[keyWidth] = autoWidth ? 'auto' : `${width}${unitWidth}`;
        if (onlyLeft || onlyTopLeft) {
          style['left'] = this.rectModal.l + (this.rectModal.w - width) + `${unitWidth}`;
          this.rectModal.view.style['left'] = style['left'];
        }
        this.rectModal.view.style[keyWidth] = style[keyWidth];
      }

      if (!onlyWidth) {
        style[keyHeight] = autoHeight ? 'auto' : `${rect.h}${unitHeight}`;
        if (onlyTop || onlyTopLeft) {
          style['top'] = this.rectModal.t + (this.rectModal.h - rect.h) + `${unitHeight}`;
          this.rectModal.view.style['top'] = style['top'];
        }
        this.rectModal.view.style[keyHeight] = style[keyHeight];
      }

      this.rectModal.view.style = this.modelToStyle.addStyle(
        { ...style, en },
        { avoidStore: !store },
      );
      const updateEvent = `update:component:style`;
      const eventToListen = `${updateEvent}:${keyHeight} ${updateEvent}:${keyWidth}`;
      em && em.trigger(eventToListen, null, null, { noEmit: 1 });
    },
    showScreenSetting() {
      var self = this;
      this.commands.add('screen-settings', function() {
        self.$nextTick(function() {
          const barsEl = document.querySelector('#gjs .gjs-pn-buttons .fa-bars');
          const brushEl = document.querySelector('#gjs .gjs-pn-buttons .fa-paint-brush');
          const decorationTitleEl = document.querySelector(
            '#gjs-sm-decoration:not(.gjs-sm-open) .gjs-sm-title',
          );
          const durationTitleEl = document.querySelector(
            '#selected-element-properties:not(.gjs-sm-open) .gjs-sm-title',
          );
          barsEl.click();
          const bodyTitleEl = document.querySelector('#gjs .gjs-layer-title');
          bodyTitleEl.click();
          brushEl.click();
          if (durationTitleEl) {
            durationTitleEl.click();
          }
          if (decorationTitleEl) {
            decorationTitleEl.click();
          }
        });
      });
    },
    showSvgMator() {
      var self = this;
      this.commands.add('show-svg-mator', function() {
        self.$nextTick(function() {
          this.image = grapesjsEMP.editors[0].getSelected().attributes;
          let ObjectSvgMator = null;
          this.ListSvgObject.forEach(s => {
            if (s.getImgId === this.image.attributes.id) {
              ObjectSvgMator = s;
            }
          });
          const obj = {
            updateLang: self.$i18n.locale,
            isVisible: true,
            src: this.image.src,
            iframe: true,
            idImg: this.image.attributes.id,
          };
          //self.$root.$emit('showModalSvgMator', obj);
          self.$root.$emit('bv::show::modal', 'modal-svg-mator');
          self.$root.$emit('loadiframe');
          window.frames['svg-iframe'].contentWindow.postMessage(obj, '*');
          //self.$root.$emit('showModalSvgMator');
        });
      });
    },
    rotateElement() {
      var self = this;
      this.commands.add('rotate-element', function() {
        self.$nextTick(function() {
          const editor = grapesjsEMP.editors[0];
          const wrapper = editor.DomComponents.getWrapper();
          let classimg = 'bg-full-img-0';
          let attributes = editor.getSelected().getAttributes();
          if (attributes['data-rotation'] && attributes['data-rotation'] == 'horizontal') {
            attributes['data-rotation'] = 'vertical';
          } else if (attributes['data-rotation'] && attributes['data-rotation'] == 'vertical') {
            attributes['data-rotation'] = 'horizontal';
          } else if (attributes) {
            attributes['data-rotation'] = 'vertical';
          } else if (attributes) {
            attributes = {};
            attributes['data-rotation'] = 'vertical';
          }

          editor.getSelected().setAttributes(attributes);
          //wrapper.view.el.setAttribute('classimg',editor.getSelected().attributes.classes.models[0].id);
        });
      });
    },
    FullbackgroundImg() {
      var self = this;
      this.commands.add('full-background-img', function() {
        self.$nextTick(function() {
          const editor = grapesjsEMP.editors[0];
          const wrapper = editor.DomComponents.getWrapper();
          const src = editor.getSelected().attributes.src
            ? editor.getSelected().attributes.src
            : editor.getSelected().attributes.attributes.src;
          wrapper.attributes.src = src;
          wrapper.view.el.setAttribute('src', src);

          // get id and class from old El  img-media
          wrapper.view.el.setAttribute('idimg', editor.getSelected().attributes.attributes.id);
          wrapper.view.el.setAttribute(
            'classimg',
            editor.getSelected().attributes.classes.models[0].id,
          );

          self.updateWrapperProperties(editor, src);
          editor.getSelected().destroy();
          // hide the toolbar of the default element after the destruction
          setTimeout(() => {
            editor.select(wrapper);
          }, 20);
        });
      });

      this.commands.add('reset-full-background-img', function() {
        self.$nextTick(function() {
          const editor = grapesjsEMP.editors[0];
          const wrapper = editor.DomComponents.getWrapper();
          let src = wrapper.attributes.src
            ? wrapper.attributes.src
            : wrapper.attributes.style['background-image']
                .slice(4, -1)
                .replace(/"/g, '')
                .replace(/'/g, ' ');
          let idimg = self.makeId();
          let classimg = 'bg-full-img-0';
          let imageMediaId = 'image-media-' + self.makeId();
          if (wrapper.view.el.attributes.idimg && wrapper.view.el.attributes.classimg) {
            idimg = wrapper.view.el.attributes.idimg.value;
            classimg = wrapper.view.el.attributes.classimg.value;
          }
          editor.addComponents(
            `<div data-gjs-type="image_media" data-highlightable="1" id="` +
              idimg +
              `"  class="` +
              classimg +
              `" src ="` +
              src +
              `"><img class="gjs-no-pointer" src=` +
              src +
              ` id="` +
              imageMediaId +
              `" style="width:100%;height:100%;border: none; overflow: hidden;"></div>`,
          );
          this.updateWrapperProperties(editor, null, this.oldBackgroundColor);
          wrapper.attributes.src = null;
          wrapper.view.el.setAttribute('src', null);
          this.displayImgBGToolBar();

          //setTimeout(() => {
          //  editor.select(wrapper);},20);
        });
      });
    },
    ShowVideoFullScreen() {
      var self = this;
      this.commands.add('full-screen-video', function() {
        self.$nextTick(function() {
          const editor = grapesjsEMP.editors[0];
          const model = editor.getSelected();
          let classes = model.getClasses();
          let cssComposer = editor.CssComposer;
          let id = grapesjsEMP.editors[0].getSelected().getAttributes().id;
          if (this.currentSlide.options.fullscreenVideo) {
            self.modeFullScreenOut(classes, cssComposer, id, model);
          } else {
            self.modeFullScreenIN(classes, cssComposer, id, model);
          }
        });
      });
    },
    modeFullScreenOut(classes, cssComposer, id, model) {
      if (classes && classes[0]) {
        cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes
          ? cssComposer.getClassRule(classes[0]).attributes.style
          : {};
        cssComposer.setClassRule(classes[0], {
          width: '30%',
          height: '30%',
          position: 'fixed',
        });
      }
      if (this.$route.name !== 'segment') {
        //this.removeBlankSlideToSegment(this.currentSegment.uid);
        this.setCurrentSlide(
          Object.assign(
            {},
            this.currentSlide,
            Object.assign({}, this.currentSlide.options, { fullscreenVideo: false }),
          ),
        );
        this.updateSegmentDuration({
          duration: model.attributes.duration,
          uid: this.currentSegment.uid,
          fullscreenVideo: false,
        });
        this.setCurrentSegment(
          Object.assign({}, this.currentSegment, { originalDuration: model.attributes.duration }),
        );
      }
      model.set('resizable', true);
    },
    modeFullScreenIN(classes, cssComposer, id, model) {
      if (classes && classes[0]) {
        cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes
          ? cssComposer.getClassRule(classes[0]).attributes.style
          : {};
        cssComposer.setClassRule(classes[0], {
          width: '100%',
          height: '100%',
          left: '0',
          top: '0',
          position: 'fixed',
        });
      }
      if (id) {
        const oldStyle = cssComposer.getIdRule(id)
          ? cssComposer.getIdRule(id).attributes.style
          : {};
        cssComposer.setIdRule(id, Object.assign({}, oldStyle, { left: '0', top: '0' }));
      }
      if (this.$route.name !== 'segment') {
        this.updateSegmentDuration({
          duration: model.attributes.duration,
          uid: this.currentSlide.uid,
          fullscreenVideo: true,
        });
      } else {
        this.updateSlideDuration({
          duration: model.attributes.duration,
          uid: this.currentSlide.uid,
        });
      }
      model.set('resizable', false);
    },
    showEditor() {
      var self = this;
      this.commands.add('show-editor', function() {
        self.$nextTick(function() {
          var selectedElement = grapesjsEMP.editors[0].getSelected().attributes.type;
          self.changeEditor(selectedElement);
        });
      });
    },

    changeEditor(element) {
      let self = this;
      document
        .querySelectorAll('.gjs-sm-sector.no-select.gjs-sm-open .gjs-sm-title')
        .forEach(function(e) {
          e.click();
        });
      var openBlocksBtn = self.editor.Panels.getButton('views', 'open-sm');
      if (element === 'image' || element === 'image_media' || element === 'pattern') {
        this.image = grapesjsEMP.editors[0].getSelected().attributes;
        self.setImageEdited(this.image.src);
        eventHub.$emit('eventShowEditorImage', true);
      } else if (element === 'text' || element === '') {
        openBlocksBtn && openBlocksBtn.set('active', 1);
        var textEditor = document.querySelector('#gjs-sm-text .gjs-sm-title');
        textEditor.click();
      } else if (element === 'player') {
        openBlocksBtn && openBlocksBtn.set('active', 1);
        var playerEditor = document.querySelector('#selected-element-properties .gjs-sm-title');
        playerEditor.click();
        document.querySelector('.gjs-mdl-dialog.gjs-one-bg.gjs-two-color').style.display = 'block';
      } else {
        var decoEditor = document.querySelector('#gjs-sm-decoration .gjs-sm-title');
        decoEditor.click();
      }
    },
    loadErrorBox() {
      // Add info command
      var self = this;
      var mdlClass = 'gjs-mdl-dialog-sm';
      var infoContainer = document.getElementById('info-erreur');
      var mdlDialog = document.querySelector('.gjs-mdl-dialog');
      mdlDialog.className += ' ' + mdlClass;
      infoContainer.style.display = 'block';
      self.modal.setTitle(self.$t('modal.error'));
      self.modal.setContent(infoContainer);
      self.modal.open();
      self.modal.getModel().once('change:open', function() {
        mdlDialog.className = mdlDialog.className.replace(mdlClass, '');
      });
    },
    loadButtonPreviewScreens() {
      var self = this;

      this.panels.addButton('options', {
        id: 'preview-screens',
        className: 'fa fa-play',
        command: function() {
          const lastSlide = {
            uid: self.currentSlide.uid,
            components: localStorage.getItem('gjs-components'),
            js: localStorage.getItem('gjs-js'),
            html: localStorage.getItem('gjs-html'),
            css: self.sanitizeCSS(localStorage.getItem('gjs-css')),
            styles: localStorage.getItem('gjs-styles'),
          };
          if (self.$route.name === 'segment') {
            self.updateSlide(lastSlide);
          } else {
            self.updateSlideInsideSegment(lastSlide);
          }
          if (self.$route.name === 'segment') {
            self.$root.$emit('ShowPreview', true);
          } else if (self.paramsClient.show_generic_display === '1') {
            if (!self.startGeneric) {
              self.setTypeGeneric('debut');
              self.$root.$emit('bv::show::modal', 'modal-add-generic', '#btnShow');
              /*} else

              if (!self.finishGeneric) {
              self.setTypeGeneric('fin');
              self.$root.$emit('bv::show::modal', 'modal-add-generic', '#btnShow');
              */
            } else {
              self.$root.$emit('ShowPreview', true);
            }
          } else if (self.paramsClient.show_generic_display === '0') {
            self.$root.$emit('ShowPreview', true);
          }
          // self.getSelectedSlides('preview');
        },
        attributes: this.setChangePreviewAttr,
      });
      // this.previewScreens();
    },

    // todo mixin code
    causedata() {
      var overlay = document.createElement('div');
      document.body.appendChild(overlay);
      overlay.setAttribute('id', 'CanvOverlay');
      overlay.setAttribute('class', 'overlay');
      var self = this;
      var infoContainer1 = document.getElementById('save-programme');
      var mdlClass = 'gjs-mdl-dialog-sm';
      const editor = grapesjsEMP.editors[0];
      let wrapper = editor.DomComponents.getWrapper();
      var iconSave = document.querySelector('.icon-save');
      editor.select(wrapper);
      setTimeout(() => {
        var btnSave = document.querySelector('#success.button-saveTemp');
        var btnload = document.querySelector('#loadButton');
        btnload.style.display = 'inline-table';
        btnSave.disabled = true;

        const lastSlide = {
          uid: self.currentSlide.uid,
          components: localStorage.getItem('gjs-components'),
          js: localStorage.getItem('gjs-js'),
          html: localStorage.getItem('gjs-html'),
          css: self.sanitizeCSS(localStorage.getItem('gjs-css')),
          styles: localStorage.getItem('gjs-styles'),
        };
        self.updateSlideInsideSegment(lastSlide);

        self.generateSlideThmbnail(self.currentSlide.uid);

        let screensToSubmit = self.selectedSegments.map(segment => {
          segment = Object.assign({}, segment);
          const t = new Date(Date.UTC(1970, 0, 1));
          t.setSeconds(segment.duration);
          segment.duration = t.toISOString();
          if (!segment.type.toLowerCase().includes('generic')) {
            segment.type = 'Segment';
          }

          segment.screensToSubmit = segment.screens.map(s => {
            let css = self.fontSizeToVw(s.css);
            css = self.widthHeightToViewport(css);
            let html = self.animationAttributesToClass(s.html);

            s.template = self.cmdInlineHtml(self.getSanitizedHtml(html), css);
            s.options.transition = s.transition;
            return s;
          });
          delete segment.screens;
          return segment;
        });

        var title = '';
        if (
          getComputedStyle(document.getElementById('title-template')).display === 'none' &&
          self.changedSave
        ) {
          title = document.getElementById('edit-title-template').value;
        } else {
          title = document.getElementById('title-template').value;
        }
        title = title || self.getTemplate.title;
        if (!self.getTemplate.title || self.changedSave) {
          var data = {
            segmentsToSubmit: screensToSubmit,
            title: title,
            template: self.deviceType,
          };
        } else {
          var data = {
            segmentsToSubmit: screensToSubmit,
            title: title,
            template: self.deviceType,
            id: self.getTemplate.id,
          };
        }
        if (self.getTemplate.id) {
          data.id = self.getTemplate.id;
        }
        self.setCauseReclamation(data);
      });
    },
    loadCommandeSaveProgramme() {
      var overlay = document.createElement('div');

      document.body.appendChild(overlay);
      overlay.setAttribute('id', 'CanvOverlay');
      overlay.setAttribute('class', 'overlay');
      var self = this;
      var infoContainer1 = document.getElementById('save-programme');
      var mdlClass = 'gjs-mdl-dialog-sm';

      function saveProgramme(e) {
        // Block saving while the program is still loading (e.g. a fast click on
        // "Enregistrer" right after opening the edit interface): saving now would
        // persist screens before their content/background is loaded and lose them.
        if (!self.editorReady) {
          self.$toasted.show(self.$t('template.loading') || 'Chargement en cours...', {
            duration: 2500,
            position: 'top-right',
            className: 'save-toast',
          });
          return;
        }
        const editor = grapesjsEMP.editors[0];
        const wrapper = editor.DomComponents.getWrapper();
        var iconSave = document.querySelector('.icon-save');
        editor.select(wrapper);
        setTimeout(() => {
          var btnSave = document.querySelector('#success.button-saveTemp');
          var btnload = document.querySelector('#loadButton');
          btnload.style.display = 'inline-table';
          btnSave.disabled = true;
          let localStorages = JSON.parse(localStorage.getItem('gjs-components')).map(item => {
            window.x = item;
            if (item.type === 'clocks') {
              item.saved = true;
            }
            return item;
          });
          localStorage.setItem('gjs-components', JSON.stringify(localStorages));
          const lastSlide = {
            uid: self.currentSlide.uid,
            components: localStorage.getItem('gjs-components'),
            js: localStorage.getItem('gjs-js'),
            html: localStorage.getItem('gjs-html'),
            css: self.sanitizeCSS(localStorage.getItem('gjs-css')),
            styles: localStorage.getItem('gjs-styles'),
          };
          self.updateSlideInsideSegment(lastSlide);

          self.generateSlideThmbnail(self.currentSlide.uid);

          let screensToSubmit = self.selectedSegments.map(segment => {
            segment = Object.assign({}, segment);
            const t = new Date(Date.UTC(1970, 0, 1));
            t.setSeconds(segment.duration);
            segment.duration = t.toISOString();
            if (!segment.type.toLowerCase().includes('generic')) {
              segment.type = 'Segment';
            }

            segment.screensToSubmit = segment.screens.map(s => {
              let css = self.fontSizeToVw(s.css);
              css = self.widthHeightToViewport(css);
              let html = self.animationAttributesToClass(s.html);

              s.template = self.cmdInlineHtml(self.getSanitizedHtml(html), css);
              s.options.transition = s.transition;
              return s;
            });
            delete segment.screens;
            return segment;
          });

          var title = '';
          if (
            getComputedStyle(document.getElementById('title-template')).display === 'none' &&
            self.changedSave
          ) {
            title = document.getElementById('edit-title-template').value;
          } else {
            title = document.getElementById('title-template').value;
          }
          title = title || self.getTemplate.title;
          if (!self.getTemplate.title || self.changedSave) {
            var data = {
              segmentsToSubmit: screensToSubmit,
              title: title,
              template: self.deviceType,
              ligne: self.getTemplate.ligne,
            };
          } else {
            var data = {
              segmentsToSubmit: screensToSubmit,
              title: title,
              template: self.deviceType,
              ligne: self.getTemplate.ligne,
              id: self.getTemplate.id,
            };
            self.$Progress.start();
          }
          if (self.getTemplate.id) {
            data.id = self.getTemplate.id;
          }
          HTTP(window.ApiToken)
            .post(Routing.generate('api_templateDisplay_post_add_edit_template'), {
              data: data,
              client: self.paramsClient.client,
              saveVideo: self.saveVideo,
            })
            .then(
              function(response) {
                if (response.data.code === 200) {
                  self.modal.close();
                  var id = response.data.templateId;
                  if (!self.getTemplate.title || self.changedSave) {
                    self.$toasted.show('Template enregistré', {
                      theme: 'bubble',
                      position: 'top-center',
                      duration: 4000,
                      icon: 'fa-check-circle',
                      className: 'save-toast',
                    });
                  } else {
                    self.$Progress.finish();
                    self.$toasted.show('Template enregistré', {
                      theme: 'bubble',
                      position: 'top-center',
                      duration: 4000,
                      icon: 'fa-check-circle',
                      className: 'save-toast',
                    });
                  }
                  self.setTemplate({
                    id: id,
                    title: title,
                  });
                  self.setShowIconSave(false);

                  iconSave.classList.remove('icon-selected');
                  if (self.saveVideo) {
                    parent.postMessage({ info: 'publishDisplay' }, '*');
                  }
                } else {
                  self.loadErrorBox();
                  self.setShowIconSave(true);
                  iconSave.classList.add('icon-selected');
                }
                btnSave.disabled = false;
                btnload.style.display = 'none';
              },
              function(error) {
                console.error(error);
                btnSave.disabled = false;
                btnload.style.display = 'none';
              },
            );
        }, 100);
      }
      function saveSegment(e) {
        const editor = grapesjsEMP.editors[0];
        const wrapper = editor.DomComponents.getWrapper();
        var iconSave = document.querySelector('.icon-save');
        editor.select(wrapper);
        setTimeout(() => {
          self.$Progress.start();
          var btnSave = document.querySelector('#success.button-saveTemp');
          var btnload = document.querySelector('#loadButton');
          btnload.style.display = 'inline-table';
          let localStorages = JSON.parse(localStorage.getItem('gjs-components')).map(item => {
            if (item.type === 'clocks') {
              item.saved = true;
            }
            return item;
          });
          localStorage.setItem('gjs-components', JSON.stringify(localStorages));
          const lastSlide = {
            uid: self.currentSlide.uid,
            components: localStorage.getItem('gjs-components'),
            js: localStorage.getItem('gjs-js'),
            html: localStorage.getItem('gjs-html'),
            css: self.sanitizeCSS(localStorage.getItem('gjs-css')),
            styles: localStorage.getItem('gjs-styles'),
          };
          self.updateSlide(lastSlide);
          self.generateSlideThmbnail(self.currentSlide.uid);
          let duration = 0;
          let screensToSubmit = self.selected.map(s => {
            duration += s.options.duration;
            let css = self.fontSizeToVw(s.css);
            css = self.widthHeightToViewport(css);
            let html = self.animationAttributesToClass(s.html);
            self.setScreensTosubmit({
              uid: s.uid,
              template: self.cmdInlineHtml(self.getSanitizedHtml(html), css),
              type: 'Screen' ? 'Disposition' : s.type,
              transition: s.transition,
              screenShot: s.screenShot,
            });
            /*
            s.template = self.cmdInlineHtml(self.getSanitizedHtml(html), css);
            s.type = s.type === 'Screen' ? 'Disposition' : s.type;
            s.template = self.cmdInlineHtml(self.getSanitizedHtml(html), css);
            s.options.transition = s.transition;
            s.screenShot = '';
            */
            return s;
          });

          let themesIdList = [];
          self.currentSegment.themes.forEach(t => {
            themesIdList.push(t.id);
          });
          let authorId = null;
          if (self.currentSegment.author) authorId = self.currentSegment.author.id;

          let key = '';
          if (self.currentSegment.keyWords && self.currentSegment.keyWords.isArray) {
            key = self.currentSegment.keyWords.join();
          }
          var data = {
            screensToSubmit: self.selected,
            title: self.currentSegment.title,
            duration: duration ? self.SecToTime(duration) : '00:00:30',
            author: authorId,
            keyWords: key ? key : null,
            description: self.currentSegment.description ? self.currentSegment.description : null,
            themes: themesIdList ? themesIdList : null,
          };

          self.setRoute('segment');
          iconSave.classList.remove('icon-selected');
          iconSave.innerText = ' ' + self.$t('template.save_and_exit');

          HTTP(window.ApiToken)
            .post(Routing.generate('api_segmentDisplay_post_add_segment'), {
              id: self.currentSegment.id ? self.currentSegment.id : null,
              data: data,
              client: self.paramsClient.client,
            })
            .then(
              function(response) {
                if (response.data.code === 200) {
                  self.$Progress.finish();
                  self.$toasted.show('Segment enregistré', {
                    theme: 'bubble',
                    position: 'top-center',
                    duration: 3000,
                    icon: 'fa-check-circle',
                    className: 'save-toast',
                  });

                  // if edit mode delet from stor
                  if (self.currentSegment.id === response.data.segmentId) {
                    self.deleteSegmentByIdStore(self.currentSegment);
                  }
                  //appendCreatedSegment : to add segment in first index list store
                  let segment = {
                    screens: response.data.screens,
                    title: self.currentSegment.title,
                    duration: self.timeToSec(data.duration),
                    type: 'DefaultSegment',
                    id: response.data.segmentId,
                    author: self.currentSegment.author ? self.currentSegment.author : null,
                    keyWords: self.currentSegment.keyWords ? self.currentSegment.keyWords : null,
                    description: self.currentSegment.description
                      ? self.currentSegment.description
                      : null,
                    themes: self.currentSegment.themes ? self.currentSegment.themes : null,
                  };

                  let index = self.$route.params.indexSegment ? self.$route.params.indexSegment : 0;
                  let info = {
                    segment: segment,
                    index: index,
                  };

                  self.appendCreatedSegment(info);

                  if (!self.biblioRoute) {
                    eventHub.$emit('saveSelect', segment);
                    self.$router.push({ name: 'add' });
                    self.$root.$emit('bv::show::modal', 'slide-list-modal');
                    eventHub.$emit('hideCancelButton', true);
                    self.setRoute('add');
                  } else {
                    self.$router.push({ name: 'ListSegment' });
                  }

                  iconSave.classList.remove('only-save');
                  iconSave.innerText = ' ';
                } else {
                  self.loadErrorBox();
                  self.setShowIconSave(true);
                  iconSave.classList.add('icon-selected');
                  iconSave.innerText = ' ' + self.$t('template.save_and_exit');

                  self.setRoute('segment');
                }
                btnSave.disabled = false;
                btnload.style.display = 'none';
              },

              function(error) {
                console.error(error);
                btnSave.disabled = false;
                btnload.style.display = 'none';
              },
            );
        }, 100);
      }

      infoContainer1.querySelector('#success').addEventListener('click', saveProgramme);
      var self = this;
      this.commands.add('save-template', function() {
        var iconSave = document.querySelector('.icon-save');
        if (self.showIconSave) {
          iconSave.classList.add('icon-selected');
        } else {
          iconSave.classList.remove('icon-selected');
        }
        function showModalSave() {
          document.querySelector('.gjs-mdl-btn-close').addEventListener('click', () => {
            if (self.showIconSave) {
              iconSave.classList.add('icon-selected');
            } else {
              iconSave.classList.remove('icon-selected');
            }
          });

          var mdlDialog = document.querySelector('.gjs-mdl-dialog');
          document.querySelector(
            '.gjs-mdl-container .gjs-mdl-dialog.gjs-one-bg.gjs-two-color',
          ).style.display = 'block';
          document.querySelector('.gjs-mdl-container .gjs-mdl-content').style.display = 'block';
          mdlDialog.className += ' ' + mdlClass;
          overlay.style.display = 'block';
          infoContainer1.style.display = 'block';
          self.modal.setTitle(self.$t('template.save_template'));
          if (self.changedSave) {
            if (!self.getTemplate.title) {
              document.getElementById('title-template').value = 'Template ' + self.makeId();
            } else {
              document.getElementById('edit-title-template').value =
                self.templateTitle + ' - Copie';
              self.modal.setTitle(self.$t('template.save_as_template'));
              document.getElementById('title-template').value = self.templateTitle;
            }
          } else {
            let title = self.getTemplate.title
              ? self.getTemplate.title.title
              : 'Template ' + self.makeId();

            document.getElementById('title-template').value = self.templateTitle || title;

            document.getElementById('edit-title-template').value = self.templateTitle || title;
          }

          self.modal.setContent(infoContainer1);
          self.modal.open();
          self.modal.getModel().once('change:open', function() {
            mdlDialog.className = mdlDialog.className.replace(mdlClass, '');
            overlay.style.display = 'none';
            if (self.showIconSave) {
              iconSave.classList.add('icon-selected');
            } else {
              iconSave.classList.remove('icon-selected');
            }
          });
        }
        function save() {
          if (
            self.paramsClient.show_generic_display === '1' &&
            self.confirmSave &&
            self.$route.name !== 'segment'
          ) {
            if (!self.startGeneric) {
              self.setTypeGeneric('debut');
              self.$root.$emit('bv::show::modal', 'modal-add-generic', '#btnShow');
              /*} else if (!self.finishGeneric) {
              self.setTypeGeneric('fin');
              self.$root.$emit('bv::show::modal', 'modal-add-generic', '#btnShow');
            */
            } else {
              if (self.showSave) {
                self.setChangedSave(true);
                showModalSave();
                self.setShowSave(false);
              } else {
                self.setChangedSave(false);
                saveProgramme();
              }
            }
          } else if (
            self.paramsClient.show_generic_display === '0' &&
            self.confirmSave &&
            self.$route.name !== 'segment'
          ) {
            if (self.showSave) {
              self.setChangedSave(true);
              showModalSave();
              self.setShowSave(false);
            } else {
              self.setChangedSave(false);
              saveProgramme();
            }
          }
        }
        // Problème 10 : suppression du message « La durée des écrans est
        // supérieure à celle de la template » — on enregistre directement.
        self.confirmSave = true;
        if (self.$route.name === 'segment') {
          saveSegment();
        }
        save();
      });
    },
    loadButtonSaveOptions() {
      var self = this;
      this.loadCommandeSaveProgramme();
      this.addSaveOptions(self.editor.Panels);
      if (document.getElementById('saveAsItem')) {
        document.getElementById('saveAsItem').addEventListener('click', () => {
          self.editor.runCommand('save-template');
        });
      }
      if (document.getElementById('saveAsVideo')) {
        document.getElementById('saveAsVideo').addEventListener('click', () => {
          self.editor.runCommand('save-template');
        });
      }
    },
    loadCommandeSaveDisposition() {
      var self = this;
      saveDisposition();

      function saveDisposition(e) {
        var icon = document.getElementById('icon-add-dispo');
        var icon2 = document.getElementById('icon-add-dispo-load');
        icon.style.display = 'none';
        icon2.style.display = 'inline-table';

        var title = 'Disposition ' + self.makeId();
        var id = 'selectedDisposition' + (self.dispositions.length + 1);
        HTTP(window.ApiToken)
          .post(
            Routing.generate('api_templateDisplay_post_screen_shot_html'),
            {
              html: self.editor.getHtml(),
              client: localStorage.getItem('client'),
            },
            {
              emulateJSON: true,
            },
          )
          .then(
            function(response) {
              let localStorages = JSON.parse(localStorage.getItem('gjs-components')).map(item => {
                window.x = item;
                if (item.type === 'clocks') {
                  item.saved = true;
                }
                return item;
              });
              localStorage.setItem('gjs-components', JSON.stringify(localStorages));
              self.addDisposition({
                js: JSON.parse(localStorage.getItem('gjs-js')),
                components: JSON.parse(localStorage.getItem('gjs-components')),
                options: {
                  duration: 30,
                  transition: 'bounce',
                  videointro: { html: '', css: '', duration: 20 },
                },
                assets: JSON.parse(localStorage.getItem('gjs-assets')),
                css: self.editor.getCss(),
                html: self.editor.getHtml(),
                styles: JSON.parse(localStorage.getItem('gjs-styles')),
                id: id,
                type: 'Disposition',
                title: title,
                screenShot: response.data.path_to_screen,
              });
              self.unshiftDisposition({
                components: JSON.parse(localStorage.getItem('gjs-components')),
                js: JSON.parse(localStorage.getItem('gjs-js')),
                options: {
                  duration: 30,
                  transition: 'bounce',
                  videointro: { html: '', css: '', duration: 20 },
                },
                assets: JSON.parse(localStorage.getItem('gjs-assets')),
                css: self.editor.getCss(),
                html: self.editor.getHtml(),
                styles: JSON.parse(localStorage.getItem('gjs-styles')),
                id: id,
                type: 'Disposition',
                title: title,
                screenShot: response.data.path_to_screen,
              });
            },
            function(error) {
              let toast = self.$toasted.show(
                "n'a pas pu créer La disposition\n verifier Votre Connexion",
                {
                  theme: 'toasted-primary',
                  position: 'top-center',
                  duration: 4000,
                },
              );
              icon.style.display = 'inline-block';
              icon2.style.display = 'none';
            },
          );
      }
    },
    loadImages() {
      var self = this;
      HTTP(window.ApiToken)
        .get(
          Routing.generate('api_bloc_get_images_stored', {
            client: localStorage.getItem('client'),
          }),
        )
        .then(
          function(response) {
            const am = self.editor.AssetManager;
            am.getAllVisible().forEach(a => {
              if (a && a.id) {
                am.remove(a.id);
              }
            });
            am.getAllVisible().models.forEach(a => {
              if (a && a.id) {
                am.remove(a.id);
              }
            });
            am.getAll().forEach(a => {
              if (a && a.id) {
                am.remove(a.id);
              }
            });
            am.getAll().models.forEach(a => {
              if (a && a.id) {
                am.remove(a.id);
              }
            });
            localStorage.setItem('gjs-assets', '[]');
            self.setAssetManager(response.data.urls);
            am.add(response.data.urls);
          },
          function(error) {},
        );
    },
    TabsComponentAdd() {
      let panels = document.querySelector('.gjs-pn-panels ');
      let parentbuttons = document.querySelector('.gjs-pn-panels .gjs-pn-panel.gjs-pn-views');
      let buttons = document.querySelector(
        '.gjs-pn-panels .gjs-pn-panel.gjs-pn-views .gjs-pn-buttons',
      );
      let toggleButton = document.createElement('div');
      toggleButton.innerHTML = '<i class="fa fa-angle-left"></i>';
      toggleButton.className = 'arrow-blocks';
      toggleButton.id = 'btn-toggle';
      toggleButton.style.display = 'block';
      buttons.classList.add('panel-buttons');
      parentbuttons.removeChild(buttons);
      panels.insertBefore(buttons, panels.firstChild);
      panels.appendChild(toggleButton);
    },
    eventLoad() {
      // Do stuff on load
      var self = this;

      this.editor.on('load', function() {
        var $ = grapesjs.$;

        let settings = document.querySelector('.gjs-toolbar');
        // Load and show settings and style manager
        var openTmBtn = self.panels.getButton('views', 'open-tm');
        openTmBtn && openTmBtn.set('active', 1);
        var openSm = self.panels.getButton('views', 'open-sm');
        openSm && openSm.set('active', 1);
        // Add Settings Sector
        var traitsSector = $(
          '<div class="gjs-sm-sector no-select" id="selected-element-properties">' +
            '<div class="gjs-sm-title">' +
            '<i id="gjs-sm-caret" class="fa fa-caret-right"></i>' +
            self.$t('button.settings') +
            '</div>' +
            '<div class="gjs-sm-properties" style="display: none;"></div></div>',
        );

        let sectors = self.styleManager.getSectors().models.map(sector => {
          return sector.attributes.id;
        });
        let id;
        sectors.forEach((sector, index) => {
          let child = $('.gjs-sm-sectors')[0].children[index];
          id = child.id;
          id = 'gjs-sm-' + sector.toLowerCase();
          child.setAttribute('id', id);
        });
        if (!document.getElementById('selected-element-properties')) {
          var traitsProps = traitsSector.find('.gjs-sm-properties');
          traitsProps.append($('.gjs-trt-traits'));
          $('.gjs-sm-sectors').before(traitsSector);
          if (!self.hasPermission('edit_duration_segment_action')) {
            traitsSector.css('height', '0');
            traitsSector.css('overflow', 'hidden');
          }
        }
        traitsSector.find('.gjs-sm-title').on('click', function() {
          if (
            self.editor.getSelected().get('type') === 'wrapper' &&
            document.querySelector('#selected-element-properties input')
          ) {
            document.querySelector('#selected-element-properties input').value = self.SecToTime(
              self.currentSlide.options.duration,
            );
          }
          const caret = document.querySelector('#selected-element-properties #gjs-sm-caret');
          const wrapper = document.querySelector('#selected-element-properties');
          let type = self.editor.getSelected().get('type');
          var traitStyle = traitsProps.get(0).style;
          if (type === '') {
            document.querySelector('.gjs-sm-sector').style.display = 'none';
            caret.className = 'fa fa-caret-right';
            wrapper.classList.remove('gjs-sm-open');
          } else {
            var hidden = traitStyle.display === 'none';
            if (hidden) {
              traitStyle.display = 'block';
              caret.className = 'fa fa-caret-down';
              wrapper.classList.add('gjs-sm-open');
            } else {
              traitStyle.display = 'none';
              caret.className = 'fa fa-caret-right';
              wrapper.classList.remove('gjs-sm-open');
            }
          }
        });
        // Open block manager
        var openBlocksBtn = self.editor.Panels.getButton('views', 'open-blocks');
        openBlocksBtn && openBlocksBtn.set('active', 1);
      });
    },
    initializeRotationPosition() {
      let self = this;
      var rotateElement = document.getElementById('rotateHandle');
      let selected = grapesjsEMP.editors[0].getSelected().view.el;
      var clientCenter = this.getRectOfElement(selected);
      let left = clientCenter.x;
      let top = clientCenter.y;
      let transform = self.getCurrentRotationFixed(selected);
      rotateElement.classList.add('drag-rotate');
      rotateElement.style.height = clientCenter.height + 30 + 'px';
      rotateElement.style.left = left + 'px';
      rotateElement.style.top = top + 'px';
      rotateElement.style.transform = 'rotate(' + transform + 'deg)';
    },
    mouse(evt) {
      if (!grapesjsEMP.editors[0].getSelected()) {
        return;
      }
      const type = grapesjsEMP.editors[0].getSelected().attributes.type;
      if (this.mouseDown /* && type === 'image'*/) {
        this.pos1 = this.pos3 - evt.clientX;
        this.pos2 = this.pos4 - evt.clientY;
        this.pos3 = evt.clientX;
        this.pos4 = evt.clientY;
        var selected = grapesjsEMP.editors[0].getSelected().view.el;
        var clientCenter = this.getRectOfElement(selected);
        var center_x = clientCenter.x;
        var center_y = clientCenter.y;
        var mouse_x = evt.pageX;
        var mouse_y = evt.pageY;
        var radians = Math.atan2(
          mouse_x - center_x,
          mouse_y - (center_y + clientCenter.height / 2),
        );
        var degree = (radians * (180 / Math.PI) + 180) * -1;
        let style = {};
        style.transform = 'rotate(' + degree + 'deg)';
        var rotateElement = document.getElementById('rotateHandle');
        rotateElement.style.transform = 'rotate(' + degree + 'deg)';
        selected.style.transform = style.transform;
        const resizer = document.querySelector('.gjs-resizer-c');
        if (resizer) {
          resizer.style.transform = style.transform;
        }
        let cssComposer = this.editor.CssComposer;
        let id = grapesjsEMP.editors[0].getSelected().getAttributes().id;
        if (!id) {
          const newId = self.makeId();
          grapesjsEMP.editor[0].getSelected().setAttributes({ id: newId });
          id = newId;
        }
        const oldStyle = cssComposer.getIdRule(id)
          ? cssComposer.getIdRule(id).attributes.style
          : {};
        cssComposer.setIdRule(id, Object.assign({}, oldStyle, style));
      }
    },
    eventComponentSelectedModel(editor) {
      let self = this;
      editor.on('component:selected', function(e) {
        let body = grapesjsEMP.editors[0].Canvas.getBody().getBoundingClientRect();
        let selected = e.view.el.getBoundingClientRect();
        self.rectModal = {
          l: (selected.left * 100) / body.width,
          t: (selected.top * 100) / body.height,
          h: (selected.height * 100) / body.height,
          w: (selected.width * 100) / body.width,
          view: e.view.el,
        };
        self.modelToStyle = editor.StyleManager.getModelToStyle(e);
      });
    },
    eventComponentSelected(editor) {
      let self = this;
      // function listenersMove() {
      //   editor.runCommand('tlb-move');
      //
      // }
      /**/

      let settings = document.querySelector('.gjs-toolbar');
      editor.on('component:hovered', model => {
        this.updateResizer(model, '.gjs-highlighter');
      });

      editor.on('component:deselected', (model, argument) => {
        let type = model.get('type');
        if (type === 'text') {
          model.addAttributes({ contenteditable: false });
        }
        if (document.getElementById('rotateHandle'))
          document.getElementById('rotateHandle').style.display = 'none';
        if (type === 'countdown' || type === 'clocks' || type === 'dateHeure') {
          model.view.updateScript();
          localStorage.setItem('gjs-js', editor.getJs());
        }
      });

      let iframe = document.querySelector('.gjs-frame');
      iframe.contentWindow.addEventListener('mouseup', () => {
        const model = editor.getSelected();
        if (model) {
          const type = model.get('type');
          if (type === 'text') {
            if (window.b) window.b.fire('selectionchange');
          }
        }
      });

      editor.on('component:selected', (model, argument) => {
        let selector = '#gjs-sm-decorations';
        self.pos1 = 0;
        self.pos2 = 0;
        self.pos3 = 0;
        self.pos4 = 0;
        let showSvg = false;
        let isVisible = false;
        let type = model.get('type');
        if (type === 'custom_column') {
          self.updateWrapperProperties(editor);
        }
        var rotateElement = document.getElementById('rotateHandle');
        if (rotateElement && type !== 'wrapper') {
          let iframe = document.querySelectorAll('.gjs-frame')[0];

          iframe.contentWindow.addEventListener('mouseup', e => {
            this.mouseDown = false;
            editor.select(editor.DomComponents.getWrapper());
          });
        }
        let exist = model.getAttributes()['data-class'];
        self.setHiddenStyleManager(model);

        //self.initializeRotationPosition();
        const props = document.getElementById('selected-element-properties');
        if (props) {
          const hidden =
            type === 'image' ||
            type === 'image_media' ||
            type === 'pattern' ||
            type === 'text' ||
            type === 'filet' ||
            type === 'custom_column2' ||
            type === 'custom_column' ||
            type === 'video_mp4' ||
            model.attributes.name === 'Cell' ||
            model.attributes.name === 'Row';
          props.style.display = hidden ? 'none' : 'block';
        }
        if (type === 'text') {
          settings.style.display = 'none';
          isVisible = true;
        } else if (type === 'image' && model.view) {
          model.view.el.setAttribute('onmousedown', 'return false;');
        }
        /* if (type === 'image') {
            var cc_Style = grapesjsEMP.editors[0].StyleManager.getModelToStyle(grapesjsEMP.editors[0].getSelected()).getStyle()
            if(cc_Style){
              cc_Style.width = '-1%'
              grapesjsEMP.editors[0].StyleManager.getModelToStyle(grapesjsEMP.editors[0].getSelected()).setStyle(cc_Style)
            }

          }*/
        if (
          model.attributes.attributes.id !== 'wrapper' ||
          model.attributes.name === 'Cell' ||
          model.attributes.name === 'Row'
        ) {
          selector = '#gjs-sm-general';
          if (document.getElementById('rotateHandle'))
            document.getElementById('rotateHandle').style.display = 'block';
        }

        self.addSettingButton(editor);

        if (
          document.querySelector(selector) &&
          !document.querySelector(selector).classList.contains('gjs-sm-open')
        ) {
          document.querySelector(selector + ' .gjs-sm-title').click();
        }

        document
          .querySelectorAll('.gjs-sm-sector.no-select.gjs-sm-open .gjs-sm-title')
          .forEach(function(e) {
            e.click();
          });
        var dispoEditor = document.querySelector('#gjs-sm-disposition .gjs-sm-title');
        if (dispoEditor) dispoEditor.click();
        this.updateResizer(model, '.gjs-resizer-c');
        self.$root.$emit('add-text-animation', isVisible);
        if (model.collection.models[0].getAttributes()['data-js']) {
          model.set('resizable', false);
        }

        if (type === 'dateHeure') {
          model.set('resizable', false);
        }
        if (type === 'video_mp4') {
          model.set('resizable', false);
        }

        if (model.attributes.type === 'linkedin_widget') {
          setTimeout(() => {
            const wrapper = document.querySelector('[data-related-type="linkedin"]');
            if (wrapper) {
              let textarea = document.createElement('textarea');
              textarea.value = wrapper.querySelector('input').value;
              textarea.setAttribute('id', 'linkedin-iframe');
              textarea.setAttribute('rows', '7');
              wrapper.appendChild(textarea);
              textarea.addEventListener('keyup', e => {
                if (/<iframe.*<\/iframe>/g.test(textarea.value)) {
                  wrapper.querySelector('input').value = textarea.value;
                }
              });

              textarea.addEventListener('keydown', e => {
                if (e.keyCode === 13) {
                  e.preventDefault();
                  textarea.blur();
                }
              });

              let errorMessage = document.createElement('div');
              errorMessage.classList.add('error-message');
              errorMessage.innerHTML = 'lien embed invalide';
              wrapper.appendChild(errorMessage);

              textarea.addEventListener('blur', () => {
                if (/<iframe.*<\/iframe>/g.test(textarea.value)) {
                  wrapper.classList.remove('has-error');
                } else {
                  wrapper.classList.add('has-error');
                }
              });
            }
          }, 500);
        }
        if (type === 'countdown' || type === 'clocks' || type === 'dateHeure') {
          model.view.updateScript();
          localStorage.setItem('gjs-js', editor.getJs());
        }
        if (model.attributes.type === 'text' || model.attributes.type === 'link') {
          if (self.paramsClient.display_fonts && self.paramsClient.display_fonts.length > 0) {
            let fonts = self.paramsClient.display_fonts;
            let classes = model.getClasses();
            let cssComposer = self.editor.CssComposer;
            let css = cssComposer.getClassRule(classes[0]);
            if (classes && classes[0]) {
              let oldStyle =
                cssComposer.getClassRule(classes[0]) &&
                cssComposer.getClassRule(classes[0]).attributes
                  ? cssComposer.getClassRule(classes[0]).attributes.style
                  : {};

              var styleFamilyFont = oldStyle['font-family'];
              var newStyleFamilyFont = oldStyle['new-font-family'];
              let newFont = styleFamilyFont;
              const fontProperty = self.editor.StyleManager.getProperty('Text', 'font-family');
              window.y = fontProperty;

              if (!exist && fonts && (styleFamilyFont || styleFamilyFont === fonts[0].value)) {
                newFont = styleFamilyFont.replace(/['"]+/g, '');
                if (self.textSelected) {
                  self.textSelected = false;
                  self.blockSelected = true;
                  if (!newStyleFamilyFont || newStyleFamilyFont === fonts[0].value) {
                    self.addCustomFonts();
                  }
                }
              } else {
                let custom = [
                  {
                    value: `Din Regular`,
                    name: `Din Regular`,
                  },
                  {
                    value: `Din bold`,
                    name: `Din bold`,
                  },
                ];
                newFont = styleFamilyFont.replace(/['"]+/g, '');
                if (self.blockSelected) {
                  self.blockSelected = false;
                  self.textSelected = true;
                  if (!newStyleFamilyFont || newStyleFamilyFont === custom[0].value) {
                    self.addCustomFonts(custom);
                  }
                }
              }
              let newStyle = Object.assign({}, oldStyle, {
                'font-family': newFont,
              });
              cssComposer.setClassRule(classes[0], newStyle);
            }
          }
          self.updatePositionCkeditors(editor);
        }
        var iconSave = document.querySelector('.icon-save');
        if (iconSave && !iconSave.classList.contains('icon-selected')) {
          iconSave.classList.remove('icon-selected');
          this.setShowIconSave(false);
        }

        const dimensions = document.getElementById('gjs-sm-dimension');
        if (dimensions) {
          const hidden = type === 'custom-countdown' || type === 'clocks' || type === 'dateHeure';
          dimensions.style.display = hidden ? 'none !important' : 'block';
        }
        const gjs = document.getElementById('gjs');
        if (type === 'countdown' || type === 'clocks' || type === 'dateHeure') {
          gjs.classList.add('grapes_edited');
        } else {
          if (gjs.classList.contains('grapes_edited')) gjs.classList.remove('grapes_edited');
        }
        this.updateAlignement();
        if (model.getAttributes()['data-class'] !== 'custom-credit') {
          self.addDefaultColors(self.editor, 'text');
        }
        if (model.getAttributes()['data-class'] !== 'custom-title') {
          self.addDefaultColors(self.editor, 'background');
        }

        if (type === 'image_media' || type === 'pattern') {
          let src = model.attributes.attributes.src
            ? model.attributes.attributes.src
            : model.view.el.firstChild.src;
          let extension = src.split('.').pop();
          if ((extension && extension === 'svg') || model.attributes.svg === 'svg') {
            model.set('svg', 'svg');
            this.ShowToolBar('object-group');
            this.displayToolBar('paint-brush');
          } else {
            this.ShowToolBar('paint-brush');
            this.displayToolBar('object-group');
          }
        }

        if (type === 'wrapper') {
          //show btn reset Full Screen  background-image
          if (model.attributes.src && model.attributes.src !== null) {
            this.showImgBGToolBars();
          } else this.displayImgBGToolBar();
        }
        // when we add new componets with ( editor.addcomponet )
        if (type === 'image_media' || type === 'pattern') {
          model.set('resizable', {
            step: 0.2,
            minDim: 3,
            currentUnit: 1,
            autoHeight: true,
            tl: 1, // Top left
            tc: 1, // Top center
            tr: 1, // Top right
            cl: 1, // Center left
            cr: 1, // Center right
            bl: 1, // Bottom left
            bc: 1, // Bottom center
            br: 1, // Bottom right
            updateTarget: this.updateTarget,
          });
        }

        window.selected = true;
        setTimeout(() => {
          window.selected = false;
        }, 1000);
      });
      // editor.on('canvas:dragover', (model, argument) => {
      //   var selected = editor.getSelected();
      //
      //   editor.runCommand('emp-move');
      // });
      // editor.on('component:deselected', model => {
      //   model.view.el.removeEventListener('mousedown', listenersMove);
      //
      //   // do your stuff...
      // });
    },
    setHiddenStyleManager(model) {
      let self = this;
      let type = model.get('type');
      let exist = model.getAttributes()['data-class'];
      let classes = model.getClasses();
      let cssComposer = self.editor.CssComposer;
      let sectors = self.editor.StyleManager.getSectors().models.map(sector => {
        return sector.attributes.id;
      });
      let ckEditor = document.querySelector('.gjs-rte-toolbar.gjs-one-bg');
      for (let sector of sectors) {
        let el = document.getElementById('gjs-sm-' + sector.toLowerCase());
        let property = document.querySelectorAll(
          '#gjs-sm-' + sector.toLowerCase() + ' .gjs-sm-properties .gjs-sm-property',
        );
        let propertyColors = document.querySelector(
          '#gjs-sm-' +
            sector.toLowerCase() +
            ' .gjs-sm-properties #gjs-sm-recent-colors-background',
        );
        if (
          type === 'text' &&
          (exist === 'custom-title' || exist === 'custom-sharing' || exist === 'custom-credit')
        ) {
          if (ckEditor) {
            ckEditor.classList.add('hide-sectors');
          }
          if (el) {
            el.classList.add('hide-sectors');
          }
          if (sector.toLowerCase() === 'disposition') {
            if (el) {
              el.classList.remove('hide-sectors');
            }
          }
          if (exist === 'custom-sharing' || exist === 'custom-title') {
            ckEditor.classList.remove('hide-sectors');
            if (sector.toLowerCase() === 'background' || sector.toLowerCase() === 'text') {
              if (property) {
                property.forEach(prop => {
                  prop.classList.add('hide-properties');
                });
              }
              if (propertyColors) {
                propertyColors.classList.add('show-properties');
              }
              if (el) {
                el.classList.remove('hide-sectors');
              }
              if (exist === 'custom-title') {
                let colors = [{ name: '', value: '#E42313' }, { name: '', value: 'transparent' }];
                self.addDefaultColors(self.editor, 'background', colors);
              }
            }
          }
          if (exist === 'custom-credit') {
            ckEditor.classList.remove('hide-sectors');
            let colors = [
              { name: '', value: '#E42313' },
              { name: '', value: '#FFFFFF' },
              { name: '', value: '#AAAAAA' },
              { name: '', value: '#252E63' },
              { name: '', value: '#081556' },
            ];
            if (sector.toLowerCase() === 'text') {
              if (property) {
                property.forEach(prop => {
                  prop.classList.add('hide-properties');
                });
              }
              let custom = [
                {
                  value: `Din Regular`,
                  name: `Din Regular`,
                },
                {
                  value: `Din bold`,
                  name: `Din bold`,
                },
              ];
              let propertyFontFamily = document.querySelector('#gjs-sm-text #gjs-sm-font-family');
              if (propertyFontFamily) {
                propertyFontFamily.classList.remove('hide-properties');
              }

              let propertyFontSize = document.querySelector('#gjs-sm-text #gjs-sm-font-size');
              if (propertyFontSize) {
                propertyFontSize.classList.remove('hide-properties');
              }

              self.addDefaultColors(self.editor, 'text', colors);
              if (!self.fontsChanged) {
                self.fontsChanged = true;
                self.addCustomFonts(custom);
              }
              if (propertyColors) {
                propertyColors.classList.add('show-properties');
              }

              if (el) {
                el.classList.remove('hide-sectors');
              }
            }
          }
        } else if (type === 'custom_column2' || type === 'custom_column' || type === 'filet') {
          if (el) {
            el.classList.add('hide-sectors');
          }

          if (sector.toLowerCase() === 'background' && type !== 'filet') {
            if (el) {
              el.classList.remove('hide-sectors');
            }
          }
        } else {
          if (type !== 'wrapper') {
            let fonts = self.paramsClient.display_fonts;
            if (classes && classes[0]) {
              let oldStyle =
                cssComposer.getClassRule(classes[0]) &&
                cssComposer.getClassRule(classes[0]).attributes
                  ? cssComposer.getClassRule(classes[0]).attributes.style
                  : {};

              var oldStyleFamilyFont =
                oldStyle && oldStyle['font-family']
                  ? oldStyle['font-family'].replace(/['"]+/g, '')
                  : oldStyle;
              if (this.$route.name !== 'edit') {
                if (
                  !oldStyleFamilyFont ||
                  (fonts && fonts[0] && oldStyleFamilyFont === fonts[0].value)
                ) {
                  self.addCustomFonts();
                }
              }
            }
          }
          if (propertyColors) {
            propertyColors.classList.remove('show-properties');
          }
          if (property) {
            property.forEach(prop => {
              prop.classList.remove('hide-properties');
            });
          }
          if (el) {
            el.classList.remove('hide-sectors');
          }
          if (ckEditor) {
            ckEditor.classList.remove('hide-sectors');
          }
        }
        if (type === 'image_media' || type === 'pattern') {
          let propertytext = document.querySelector('#gjs-sm-text');
          propertytext.classList.add('hide-sectors');
          if (sector.toLowerCase() === 'background') {
            if (property) {
              property.forEach(prop => {
                prop.classList.add('hide-properties');
              });
            }
          }
          //----------------
          document.querySelector('#gjs-sm-background .gjs-sm-title').innerHTML =
            '<i id="gjs-sm-caret" class="fa fa-caret-right"></i> ' +
            this.$i18n.t('styleManager.color');
          let icon = document.querySelector('#gjs-sm-background  #gjs-sm-caret');
          document
            .querySelector('#gjs-sm-background .gjs-sm-title')
            .addEventListener('click', function() {
              if (icon.classList[1] === 'fa-caret-right') {
                icon.classList.remove('fa-caret-right');
                icon.classList.add('fa-caret-down');
              } else {
                icon.classList.remove('fa-caret-down');
                icon.classList.add('fa-caret-right');
              }
            });
        }else if(type==='clocks') {
          if (sector.toLowerCase() === 'background' || sector.toLowerCase() === 'text') {
            if (el) {
              el.classList.add('hide-sectors');
            }
          }
        }else{
            document.querySelector('#gjs-sm-background .gjs-sm-title').innerHTML =
              '<i id="gjs-sm-caret" class="fa fa-caret-right"></i> ' +
              this.$i18n.t('styleManager.background');
            let icon = document.querySelector('#gjs-sm-background  #gjs-sm-caret');
            document
              .querySelector('#gjs-sm-background .gjs-sm-title')
              .addEventListener('click', function() {
                if (icon.classList[1] === 'fa-caret-right') {
                  icon.classList.remove('fa-caret-right');
                  icon.classList.add('fa-caret-down');
                } else {
                  icon.classList.remove('fa-caret-down');
                  icon.classList.add('fa-caret-right');
                }
              });
          }
        }
    },
    addAttributesWrapper(wrapper) {
      wrapper.set('attributes', { 'data-gjs-emp-wrapper': 'em-display' });
      wrapper.set('attributes', { id: 'wrapper' });
    },
    addTraitsToWrapper() {
      var self = this;
      var wrapper = this.editor.DomComponents.getWrapper();
      this.addTypeNumber(wrapper);
      wrapper.get('traits').add({
        name: 'duration',
        type: 'duration',
        units: ['s'],
        property: 'flex-basis',
        toRequire: 1,
        label: self.$t('labels.duration'),
      });
      this.addAttributesWrapper(wrapper);
    },
    addTypeNumber(wrapper) {
      var self = this;
      this.editor.TraitManager.addType('duration', {
        events: {
          keyup: 'onChange', // trigger parent onChange method on keyup
        },
        /**
         * Returns the input element
         * @return {HTMLElement}
         *
         */
        getInputEl: function() {
          if (!this.inputEl) {
            var input = document.createElement('input');
            input.value = '00:00:20';
            input.placeholder = 'hh:mm:ss';
            this.inputEl = input;
          }
          return this.inputEl;
        },
        /**
         * Triggered when the value of the model is changed
         */
        onValueChange: function() {
          const duration = this.model.get('value');
          if (self.currentSlide != null) {
            const inputEl = document.querySelector('#selected-element-properties input');
            if (duration.length > 3) {
              const isValid = this.validateTime(inputEl.value);
              if (!isValid) {
                inputEl.value = self.SecToTime(self.timeToSec(duration));
                return;
              }
            }
            if (duration.length === 2 || duration.length === 5) {
              inputEl.value = duration + ':';
            } else if (duration.length >= 8) {
              inputEl.value = self.SecToTime(self.timeToSec(duration));
            }

            const data = {
              duration: self.timeToSec(duration),
              uid: self.currentSlide.uid,
            };
            if (self.$route.name !== 'segment') {
              self.updateSegmentDuration(data);
            } else {
              self.setSlideDuration(data);
            }
          }
        },
        validateTime: function(value) {
          const pattern = new RegExp('^((\\d)?\\d:)?[0-5]?[0-9]:[0-5]?[0-9]$');
          return pattern.test(value);
        },
      });
    },
    updateWidthImage(params) {
      const { img, className } = params;
      const iframeEl = document.querySelector('.gjs-cv-canvas .gjs-frame');
      const iframeWidth = parseFloat(window.getComputedStyle(iframeEl).width);
      const iframeHeight = parseFloat(window.getComputedStyle(iframeEl).height);

      let cssComposer = this.editor.CssComposer;

      let oldStyle =
        cssComposer.getClassRule(className) && cssComposer.getClassRule(className).attributes.style
          ? cssComposer.getClassRule(className).attributes.style
          : {};

      const height = (parseFloat(oldStyle.height) * iframeHeight) / 100;
      const width = (parseFloat(oldStyle.width) * iframeWidth) / 100;

      const oldRatio = width / height;
      const newRatio = img.width / img.height;

      let style = {
        position: 'fixed',
        width: 'auto',
        height: 'auto',
      };

      if (
        oldStyle.height &&
        oldStyle.height !== 'auto' &&
        oldStyle.width &&
        oldStyle.width !== 'auto'
      ) {
        if (oldRatio > newRatio) {
          style.height = oldStyle.height;
          style.width = parseInt(((height * newRatio) / iframeWidth) * 100) + '%';
        } else {
          style.width = oldStyle.width;
          style.height = parseInt((width / newRatio / iframeHeight) * 100) + '%';
        }
      } else {
        if (newRatio > iframeWidth / iframeHeight) {
          style.width = '50%';
        } else {
          style.height = '50%';
        }
      }

      const newStyle = Object.assign({}, oldStyle, style);
      cssComposer.setClassRule(className, newStyle);
    },
    createToggleButton(styleManager) {
      let sectors = styleManager.getSectors().models.map(sector => {
        return sector.attributes.id;
      });
      for (let sector of sectors) {
        let btnToggle = document.createElement('button');
        btnToggle.innerHTML =
          '<i class="fa fa-caret-down"></i><span class="params-text">' +
          i18n.t('blocks.params') +
          '</span>';
        btnToggle.value = 'off';
        btnToggle.id = 'button-' + sector.toLowerCase();
        btnToggle.className = 'btn btn-block btn-outline-secondary btn-sm my-3';
        if (
          sector.toLowerCase() === 'disposition' ||
          sector.toLowerCase() === 'dimension' ||
          sector.toLowerCase() === 'decoration'
        ) {
          const el = document.querySelector(
            '#gjs-sm-' +
              sector.toLowerCase() +
              ' .gjs-sm-properties #gjs-sm-params-' +
              sector.toLowerCase(),
          );
          if (!el) {
            return false;
          }
          el.appendChild(btnToggle);
          btnToggle.addEventListener('click', function() {
            document
              .querySelector('#gjs-sm-' + sector.toLowerCase() + ' .gjs-sm-properties')
              .classList.toggle('hide-advanced-properties');
          });
          document
            .querySelector('#gjs-sm-' + sector.toLowerCase() + ' .gjs-sm-properties')
            .classList.add('hide-advanced-properties');
        }
      }
      return true;
    },
    updateStyleInputBackground(styleManager) {
      let backgroundEl = styleManager.filter(st => st.name.toLowerCase() === 'background');
      if (backgroundEl) {
        let elButtonAdd = document.querySelector(
          '#gjs-sm-background .gjs-sm-properties #gjs-sm-background .gjs-fields .gjs-sm-field #gjs-sm-add',
        );
        let div = document.createElement('div');
        div.setAttribute('id', 'gjs-sm-add-btn');
        div.setAttribute('class', 'gjs-sm-add-btn');
        let elParentField = document.querySelector(
          '#gjs-sm-background .gjs-sm-properties #gjs-sm-background .gjs-fields .gjs-sm-field.gjs-sm-stack',
        );
        let backgEls = document.querySelector(
          '#gjs-sm-background .gjs-sm-properties #gjs-sm-background .gjs-fields .gjs-sm-field.gjs-sm-stack div[data-layers-wrapper] .gjs-sm-layers.gjs-field',
        );
        if (!elParentField) {
          return false;
        }
        if (!elButtonAdd) {
          return false;
        }
        if (!backgEls) {
          return false;
        }
        if (elParentField && elButtonAdd) {
          div.innerHTML = '<span class="text-add">' + this.$i18n.t('labels.text-add') + '</span>';
          div.appendChild(elButtonAdd);
          elParentField.appendChild(div);
        }
      }
      return true;
    },
    updateResizer(model, selector) {
      let id = model.getAttributes().id;
      let child = this.editor.CssComposer.getIdRule(id);
      const resizer = document.querySelector(selector);
      const rect = model.view.el.getBoundingClientRect();
      if (resizer) {
        resizer.style.transform = 'rotate(0)';
      }
      if (child && resizer) {
        let style = child.attributes.style;
        const transform = style.transform;
        if (!transform) {
          return;
        }
        const degree = parseFloat(transform.replace('rotate(', '').replace('deg)', ''));

        resizer.style.transform = style.transform;
        resizer.style.transformOrigin = 'left top';

        const height = parseFloat(window.getComputedStyle(model.view.el).height);
        const width = parseFloat(window.getComputedStyle(model.view.el).width);

        if (degree <= -270) {
          const deviation = Math.sin((degree * Math.PI) / 180) * height;
          setTimeout(() => {
            resizer.style.left = parseFloat(resizer.style.left) + deviation + 'px';
          }, 100);
        } else if (degree <= -180) {
          const deviation = Math.sin(((degree - 90) * Math.PI) / 180) * height;
          setTimeout(() => {
            resizer.style.left = parseFloat(resizer.style.left) + rect.width + 'px';
            resizer.style.top = parseFloat(resizer.style.top) + deviation + 'px';
          }, 100);
        } else if (degree <= -90) {
          const deviation = Math.sin(((degree - 180) * Math.PI) / 180) * height;
          setTimeout(() => {
            resizer.style.left = parseFloat(resizer.style.left) + deviation + 'px';
            resizer.style.transform = 'rotate(' + (degree - 180) + 'deg)';
          }, 100);
        } else {
          const deviation = Math.sin(((degree - 180) * Math.PI) / 180) * width;
          setTimeout(() => {
            resizer.style.top = parseFloat(resizer.style.top) + deviation + 'px';
          }, 100);
        }
      }
    },
    addCustomFonts(customFonts) {
      let self = this;
      let fontProperty = this.editor.StyleManager.getProperty('Text', 'font-family');
      let fonts = self.paramsClient.display_fonts;
      if (customFonts && customFonts.length > 0) {
        fonts = customFonts;
      }
      fontProperty.attributes.options = [];
      fontProperty.attributes.list = [];
      // let list = this.editor.StyleManager.getProperty('Text', 'font-family').get('list');
      if (fonts && fonts.length > 0) {
        var list = [];
        fontProperty.set('list', list);
        fonts.forEach(function(element) {
          if (list.indexOf(element) === -1) {
            list.push(
              self.editor.StyleManager.getProperty('Text', 'font-family').addOption({
                value: element.value.replace(/['"]+/g, ''),
                name: element.name,
              }),
            );
          }
        });
      }

      // self.editor.StyleManager.render();
    },

    permissionUndoRepeat() {
      if (!this.paramsClient.modules.undo_redo_action) {
        var style = document.createElement('style');
        document.head.appendChild(style);
        let undoRedos = ['undo', 'repeat'];
        for (let i = 0; i < undoRedos.length; i++) {
          style.sheet.insertRule(' span.gjs-pn-btn.fa.fa-' + undoRedos[i] + '{ display:none; }');
        }
      }
    },

    /*Todo Mixin code*/
    permissionEyePreview() {
      if (!this.paramsClient.modules.eye_preview_action) {
        var style = document.createElement('style');
        document.head.appendChild(style);
        style.sheet.insertRule(' span.gjs-pn-btn.fa.fa-eye{ display:none; }');
      }
    },
    permissionCleanCanvas() {
      if (!this.paramsClient.modules.clean_canvas_action) {
        var style = document.createElement('style');
        document.head.appendChild(style);
        style.sheet.insertRule(' span.gjs-pn-btn.fa.fa-trash{ display:none; }');
      }
    },
    displayToolbarButtons(editor) {
      let showToolbar = false;
      let selected = editor.getSelected();
      let type = selected.attributes.type;
      if (this.showToolbarButtons === false && type === 'social_media') {
        showToolbar = true;
      }
      if (showToolbar) {
        this.showHideToolBars('arrows');
      }
      if (showToolbar) {
        this.showHideToolBars('clone');
      }
    },
    permissionToolBar() {
      if (this.permission.display_toolbar) {
        if (!this.permission.display_toolbar.drag) {
          //Mixin Code : displayToolBar
          this.displayToolBar('arrows');
        }

        if (!this.permission.display_toolbar.delete) {
          this.displayToolBar('trash-o');
        }

        if (!this.permission.display_toolbar.duplicate) {
          this.displayToolBar('clone');
        }

        if (!this.permission.display_toolbar.edit) {
          this.displayToolBar('paint-brush');
        }

        if (!this.permission.display_toolbar.parameter) {
          this.displayToolBar('cogs');
        }
      }
    },

    getDevices() {
      setTimeout(() => {
        const devices = document.querySelector('.gjs-pn-devices-b');
        // devices.style.display = 'none';
      }, 100);
    },
    isPluginIframe() {
      let self = this;
      if (self.paramsClient.display_default_blocks) {
        let existImage = false;
        let existSocial = false;
        let existPattern = false;
        let id;
        let comp;
        let blocks = self.paramsClient.display_default_blocks.map(block => {
          return block.blocks;
        });
        for (let i = 0; i < blocks.length; i++) {
          blocks[i].forEach(item => {
            if (item.indexOf('image_media') > -1) {
              existImage = true;
              return existImage;
            }
            if (item.indexOf('social_media') > -1) {
              existSocial = true;
              return existSocial;
            }
            if (item.indexOf('pattern') > -1) {
              existPattern = true;
              return existPattern;
            }
          });
        }
        if (existImage) {
          id = 'image-media';
          comp = 'image_media';
          this.addModalUploadIframePlugin(id);
          this.changeModalBackgImage(this.editor, comp, id);
        }
        if (existSocial) {
          id = 'social-media';
          comp = 'social_media';
          this.addModalUploadIframePlugin(id);
        }
        if (existPattern) {
          id = 'pattern';
          comp = 'pattern';
          this.addModalUploadIframePlugin(id);
          this.changeModalBackgImage(this.editor, comp, id);
        }
      }
    },
    setHiddenButtonDevice() {
      setTimeout(() => {
        document.querySelector('.gjs-pn-devices-b').style.display = 'none';
      }, 100);
    },
  },

  async mounted() {
    //this.eventGetMessageFromsvgFrame();

    var self = this;

    if (
      this.paramsClient.display_devices &&
      Object.keys(this.paramsClient.display_devices).length === 1
    ) {
      this.setHiddenButtonDevice();
    }

    // permissionUndoRepeat
    self.permissionUndoRepeat();
    self.permissionEyePreview();
    self.permissionCleanCanvas();
    // permissionToolBar
    self.permissionToolBar();
    self.getDevices();
    const customStyleManager = JSON.parse(
      JSON.stringify(self.paramsClient.display_custom_style_manager),
    );

    storage_init.pluginsOpts['gjs-preset-webpage'].customStyleManager = customStyleManager;
    var editor = {};
    if (grapesjs && grapesjs.editors && grapesjs.editors[0]) {
      grapesjs.editors = [];
      editor = grapesjs.init(storage_init);
      grapesjs.editors.push(editor);
    } else {
      editor = grapesjs.init(storage_init);
    }

    //  this.addCustomStyleManager(editor, this.paramsClient);
    this.editor = editor;
    this.blockManager = editor.BlockManager;
    this.panels = editor.Panels;
    this.modal = editor.Modal;
    this.commands = editor.Commands;
    this.styleManager = editor.StyleManager;
    bus.$on('setFormLang', code => {
      i18n.locale = code;

      this.$i18n.locale = code;
      this.addBeautifyTooltips(this.panels);
      this.translateBlocksName(this.blockManager.getAll().models);
      this.updateCategoryBlockManger(this.editor, this.paramsClient);
      this.translateStyleManagerName(this.styleManager.getSectors().models);
    });
    let index = 0;
    let interval = setInterval(() => {
      const done = this.createToggleButton(this.styleManager);
      index++;
      if (done || index === 20) {
        clearInterval(interval);
      }
    }, 1000);

    eventHub.$on('updateWidthImage', self.updateWidthImage);
    editor.DomComponents.addType('image', {
      model: {
        defaults: {
          resizable: {
            step: 0.2,
            minDim: 3,
            currentUnit: 1,
            autoHeight: true,
            tl: 1, // Top left
            tc: 1, // Top center
            tr: 1, // Top right
            cl: 1, // Center left
            cr: 1, // Center right
            bl: 1, // Bottom left
            bc: 1, // Bottom center
            br: 1, // Bottom right
          },
        },
      },
    });
    editor.DomComponents.addType('countdown', {
      model: {
        defaults: {
          traits: [
            {
              label: 'Début',
              name: 'startfrom',
              changeProp: 1,
              type: 'datetime-local',
            },
            {
              label: 'Fin du texte',
              name: 'endText',
              changeProp: 1,
            },
          ],
          resizable: {
            step: 0.2,
            minDim: 10,
            maxDim: 100,
            currentUnit: 1,
            autoHeight: true,
            tl: 1, // Top left
            tc: 0, // Top center
            tr: 1, // Top right
            cl: 0, // Center left
            cr: 0, // Center right
            bl: 1, // Bottom left
            bc: 0, // Bottom center
            br: 1, // Bottom right
          },
          copyable: true,
        },
      },
    });

    this.setEditor(editor);
    this.setDeviceManagerEditor(editor, this.paramsClient);
    this.setDeviceEditor(editor, this.paramsClient);
    if (
      this.paramsClient.display_fonts &&
      this.paramsClient.display_fonts.length > 0 &&
      this.$route.name !== 'edit'
    ) {
      this.addCustomFonts();
    }

    this.eventComponentUpdateCountDown(editor);
    this.eventComponentUpdateStyleBackgroundImage(editor);
    this.eventEditText(editor);
    this.eventDragEnd(editor);
    var tools = grapesjs.editors[0]
      .getModel()
      .get('Canvas')
      .getToolsEl();
    /*var element = document.createElement('div');
      element.id = 'rotateHandle';
      element.className = 'rotate-handle';
      element.style.display = 'none';
      element.style.position = 'absolute';

      tools.appendChild(element);
      element.addEventListener('mousedown', function(e) {
        self.mouseDown = true;
      });
      let iframe = document.querySelectorAll('.gjs-frame')[0];
      iframe.contentWindow.addEventListener('mousemove', function(e) {
        self.mouse(e);
      });*/
    editor.DomComponents.addType('text', {
      model: {
        defaults: {
          resizable: {
            step: 0.1,
            minDim: 3,
            currentUnit: 1,
            autoHeight: true,
            tl: 0, // Top left
            tc: 1, // Top center
            tr: 0, // Top right
            cl: 1, // Center left
            cr: 1, // Center right
            bl: 0, // Bottom left
            bc: 1, // Bottom center
            br: 0, // Bottom right
          },
        },
      },
    });
    // editor.DomComponents.addType('video', {
    //   model: {
    //     defaults: {
    //       attributes: {
    //         muted: true,
    //       },
    //     },
    //   },
    // });
    //this.eventAutoPlayVideo(editor);
    this.$root.$on('isVideoAutoplay', object => {
      let videoArray = ['video', 'player', 'video_mp4', 'playlist'];
      let cssComposer = editor.CssComposer;
      let model = object.model;
      let classes = model.getAttributes().class;
      if (videoArray.indexOf(object.video.type) > -1) {
        const lastSlide = {
          uid: self.currentSlide.uid,
          components: JSON.stringify(object.video),
          js: localStorage.getItem('gjs-js'),
          html: localStorage.getItem('gjs-html'),
          css: self.sanitizeCSS(localStorage.getItem('gjs-css')),
          styles: localStorage.getItem('gjs-styles'),
        };
        if (classes) {
          classes = classes.split(' ');
          if (classes && classes[0]) {
            let oldStyle =
              cssComposer.getClassRule(classes[0]) &&
              cssComposer.getClassRule(classes[0]).attributes
                ? cssComposer.getClassRule(classes[0]).attributes.style
                : {};

            let obj = { 'background-color': 'black' };
            let newStyle = Object.assign({}, oldStyle, obj);
            cssComposer.setClassRule(classes[0], newStyle);
          }
        }
        if (this.$route.name === 'segment') {
          this.updateSlide(lastSlide);
        } else {
          this.updateSlideInsideSegment(lastSlide);
        }
      }
    });
    this.eventPausedPlayer(editor);
    this.eventComponentAdd(editor);
    this.eventComponentStyleUpdate(editor);
    this.eventComponentUpdate(editor);
    this.eventComponentSelectedModel(editor);
    this.eventComponentUpdateWidthSrc(editor);
    this.eventRunPreview(editor);
    this.eventStopPreview(editor);

    this.eventComponentSelected(editor);
    this.eventComponentUpdateImage(editor);
    this.eventCommandRun(editor);
    this.eventDelete(editor);
    this.eventFullScreen(editor);
    this.eventImageAdded(editor);
    this.eventClockAdded(editor);
    this.eventDateHeureAdded(editor);

    this.eventComponentStyleUpdateImageHeightOrWidht(editor);
    this.updateEditableTextHeight(editor);
    this.$root.$on('updateCanvasContent', () => {
      localStorage.setItem('id', this.currentSlide.id);
      this.updateSelectedComponent(editor, this.currentSlide);
      editor.addComponents(
        '<style>html{overflow: hidden; user-select: none}#wrapper{height:100%}</style>',
      );
    });
    this.$root.$on('saveCurrentDisposition', val => {
      this.loadCommandeSaveDisposition();
    });

    this.$root.$on('clearCanvas', () => {
      self.editor.DomComponents.clear();
    });
    this.$root.$on('oldBackgroundColor', val => {
      this.oldBackgroundColor = val;
    });

    editor.on('load', () => {
      //this.$root.$emit('updateCanvasContent');
      const layerBtn = document.querySelector('.gjs-pn-btn.fa-bars');
      eventHub.$emit('loadGrapes');
      grapesjsEMP.editors[0].on('canvas:dragover', function(model) {
        if (document.querySelector('.gjs-frame').contentWindow.getSelection().type === 'Range')
          event.stopPropagation();
      });

      if (this.permission.display_layers) {
        layerBtn.addEventListener('click', () => {
          grapesjsEMP.editors[0].LayerManager.render();
          this.handleLayersPanel(editor);
        });
      } else {
        layerBtn.style.display = 'none';
      }
    });
    await this.updateCategoryBlockManger(this.editor, this.paramsClient);
    //************wrapper*************//
    this.addTraitsToWrapper();
    this.translateBlocksName(this.blockManager.getAll().models);
    this.translateBlocksName(this.blockManager.getCategories().models);
    this.translateStyleManagerName(this.styleManager.getSectors().models);
    this.showSvgMator();
    this.FullbackgroundImg();
    this.rotateElement();
    this.ShowVideoFullScreen();
    this.loadCanvasClear(this.commands);
    this.showSetting();
    this.showScreenSetting();
    this.showEditor();
    this.loadButtonPreviewScreens();
    this.eventComponentCloneElement(editor);
    this.loadButtonSaveOptions();
    this.loadScreens(this.panels);
    this.addBeautifyTooltips(this.panels);
    this.showBorders(this.panels);
    this.eventLoad();
    this.loadImages();
    this.addPanels(this.panels);
    this.loadShowListPages(this.commands);
    this.dragElements(this.commands);
    self.removeButtons(this.panels);
    self.listenerFullScreen();
    //self.clickFullScreen();
    self.clickPreview();
    this.createBorderProperty(editor);
    this.eventStorageEndStore(editor);
    window.grapesjsEMP = grapesjs;
    this.TabsComponentAdd();
    this.isPluginIframe();
    var wrapper = this.editor.DomComponents.getWrapper();
    var range = document.querySelector('.gjs-field.gjs-field-range input');
    if (range) {
      range.addEventListener(
        'input',
        function() {
          let val = 1 - range.value;
          wrapper.set('style', { 'background-color': 'rgba(255, 255, 255,' + val + ')' });
        },
        false,
      );
    }
    setTimeout(() => {
      this.initClone();
      this.eventColorPickerListener();
      this.addDefaultColors(this.editor, 'text');
      this.addDefaultColors(this.editor, 'background');
      if (Object.keys(this.paramsClient.display_default_blocks).length > 2) {
        this.setHiddenBlockManager();
      }
      //this.updateStyleInputBackground(customStyleManager);
    }, 1000);
    this.eventComponentStyleAlign(this.editor);
    eventHub.$on('showToolbarButtons', val => {
      this.showToolbarButtons = val;
      self.displayToolbarButtons(editor);
    });

    document.addEventListener(
      'callFullScreenMethode',
      function(e) {
        self.updateSegmentDuration({
          duration: e.myDuration,
          uid: self.currentSlide.uid,
          fullscreenVideo: true,
        });
        // e.target matches elem
      },
      false,
    );

    let buttonFullScreen = document.querySelector('.gjs-pn-btn.fa.fa-arrows-alt');
    buttonFullScreen.addEventListener('click', function() {
      if (buttonFullScreen.classList.contains('gjs-pn-active')) {
        //is open
        let data = { info: 'fullScreen', value: true };
        parent.postMessage(data, '*');
      } else {
        //is closed
        let data = { info: 'fullScreen', value: false };
        parent.postMessage(data, '*');
      }
    });

    /*setTimeout(function() {
        const container = document.querySelector('.gjs-pn-views-container > div:nth-child(2)');
        const ps = new PerfectScrollbar(container);
      }, 1000);*/
    /*
      setTimeout(() => {
        var btn = document.createElement('BUTTON'); // Create a <button> element
        btn.className = 'btn btn-block btn-outline-secondary btn-sm my-3';
        btn.innerHTML = '<i class="fa fa-caret-down mr-2"></i>paramètres avancés'; // Insert text
        document.getElementById('gjs-sm-float').appendChild(btn);
      }, 1000);*/
  },
};
</script>
<style lang="scss">
@import '../../static/css/tooltip.css';
@import '../../static/css/grapesjs-plugin-filestack.css';
@import '../../static/css/demos.css';
@import '../../static/css/grapes.min.css';
@import '../../static/css/uep-icon.css';
@import '../../static/css/grapesjs-preset-webpage.min.css';
@import '../scss/grapes_emp.scss';

.icon-add-comp::before,
.icon-comp100::before,
.icon-comp50::before,
.icon-comp30::before,
.icon-rm::before {
  content: '';
}

.icons-flex {
  background-size: 40% 50% !important;
  height: 25px;
  width: 30px;
  opacity: 0.9;
}

[data-tooltip]::after {
  background: rgba(51, 51, 51, 0.9);
}

.gjs-pn-commands {
  min-height: 40px;
}

#gjs-sm-float,
.gjs-pn-views .fa-cog {
  display: none;
}

.gjs-pn-panels .fa-cog {
  display: none;
}

.gjs-logo-version {
  background-color: #756467;
}

.gjs-pn-panel.gjs-pn-views {
  padding: 0;
  border-bottom: none;
}

.gjs-pn-btn.gjs-pn-active {
  box-shadow: none;
}

.gjs-pn-views .gjs-pn-btn {
  margin: 4px;
  height: 32px;
  width: 32px;
  padding: 6px;
}

.gjs-pn-views-container .gjs-pn-btn {
  margin: 4px;
  height: 32px;
  width: 32px;
  padding: 6px;
}

.CodeMirror {
  min-height: 450px;
  margin-bottom: 8px;
}

.container {
  margin: 0 auto;
}

ul {
  margin-right: 11%;
}

ul.tabs {
  margin: 0px;
  padding: 0px;
  list-style: none;
}

ul.tabs li {
  background: none;
  color: #d8d8d8;
  width: 85%;
  display: inline-block;
  padding: 10px 15px;
  cursor: pointer;
  opacity: 0.5;
  font-size: 16px;
}

ul.tabs li.current {
  background: #262b34;
  color: #d8d8d8;
  opacity: 1;
  font-weight: bold;
  font-size: 16px;
}

.tab-content {
  display: none;
  background: rgb(45, 51, 62);
  padding: 15px;
}

.tab-content.current {
  overflow-x: hidden;
  overflow-y: auto;
  display: inherit;
  height: 100%;
}

.selected-generique {
  border-radius: 3px;
  background: #2196f3;
  height: 60px !important;
  cursor: pointer;
  min-width: 2px !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  margin: 14px 5px;
  transition: 0.3s ease;
}

.add-segment {
  border-radius: 3px;
  background: #2196f3;
  height: 90px !important;
  cursor: pointer;
  min-width: 125px !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  margin: 14px 5px;
  transition: 0.3s ease;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
  display: none;
  background-color: rgba(0, 0, 0, 0.7); /*dim the background*/
}

.live-it-icon {
  background-size: 25%;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url('../assets/img/live.svg');
}

.live-it-icon div {
  padding-top: 53%;
}

.hide-btn-add {
  left: -300px;
}

.font {
  margin-right: 20px;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}

#editor .player-item:hover img {
  filter: brightness(60%);
  cursor: pointer;
}

#editor .player-item img {
  width: 100%;
  height: auto !important;
}

.hidden {
  display: none;
}

.gjs-clm-tags {
  display: none !important;
}

.icons-layers-background,
.icons-layers-size {
  background-size: 40% 40% !important;
  height: 25px;
  width: 25px;
  opacity: 0.9;
}

.dropdown-save-ul {
  list-style-type: none;
  padding: 10px;
  margin: 0;
  color: #1f1f1f;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 14px;
}

.dropdown-save-li {
  padding: 5px 10px;
  cursor: pointer;
}

.full-BG {
  top: 3.2em;
  position: absolute;
  right: 10px;
}
.reset-full-BG {
  top: 1em;
  position: absolute;
  right: 10px;
}
.bg-full-img-0 {
  position: fixed;
  z-index: 2;
  width: 50%;
  height: 50%;
  left: 25%;
  top: 25%;
}
</style>



// WEBPACK FOOTER //
// GrapesWrapper.vue?fcef0ec6